import { Settings } from '@mui/icons-material';
import {
  Button,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import EmptyNotification from '../../../public/assets/empty-notifications.png';
import { NotificationTypes, OrderTypes } from '../../common/enums/enums';
import NotificationCard from './NotificationCard';
import NotificationCenterTab from './NotificationCenterTab';
import NotificationLoadingCard from './NotificationLoadingCard';

export default function CenterTab({
  onClose,
  notifications,
  openConfiguration,
  onPerformAction,
  onMarkAllAsRead,

  loading,
  hasNextPage,
  forwardRef,
}) {
  const { t } = useTranslation('global');

  let footer = <></>;
  let divider = <></>;
  let body = (
    <Stack flexGrow={1} alignItems="center" justifyContent="center" gap={2}>
      <img src={EmptyNotification} alt="Empty" width={72} />
      <Stack gap={1} alignItems="center">
        <Typography variant="h6">
          {t('notifications.noNotifications')}
        </Typography>
        <Typography>{t('notifications.noNotificationsCaption')}</Typography>
      </Stack>
    </Stack>
  );

  const getType = notification => {
    if (notification.payload.updatedAt) return NotificationTypes.ORDER_EDITED;
    if (notification.payload.orderType === OrderTypes.RECONDITIONING)
      return NotificationTypes.ESTIMATE_APPROVAL;
    return notification.type;
  };

  if (notifications?.length) {
    body = notifications
      .map(notification => ({
        ...notification,
        type: getType(notification),
      }))
      .map((notification, index) => (
        <NotificationCard
          key={`notification_${index}`}
          onPerformAction={() => onPerformAction(notification)}
          {...notification}
        />
      ))
      .concat(
        Array.from({ length: ((loading || hasNextPage) && 5) || 0 }).map(
          (_, index) => (
            <NotificationLoadingCard
              forwardRef={(!index && forwardRef) || null}
              key={index}
            />
          )
        )
      );

    footer = (
      <Button size="small" onClick={onMarkAllAsRead}>
        {t('notifications.markAll')}
      </Button>
    );
    divider = <Divider />;
  }

  return (
    <NotificationCenterTab
      header={
        <>
          <Typography variant="h6" flexGrow={1}>
            {t('notifications.title')}
          </Typography>
          <Tooltip title={t('notifications.settingsTooltip')} arrow>
            <IconButton
              size="small"
              onClick={openConfiguration}
              sx={{
                '& :hover': {
                  color: 'primary.main',
                },
              }}
            >
              <Settings />
            </IconButton>
          </Tooltip>
        </>
      }
      body={body}
      footer={
        <>
          {divider}
          <Stack p={2} justifyContent="center" alignItems="baseline">
            {footer}
          </Stack>
        </>
      }
      onClose={onClose}
    />
  );
}
